<script>
import ScenarioService from "@/services/scenario.service";
import {mapState} from "vuex";
import {ScenarioEventBus, ScenarioEventBusType} from "@/views/Scenario/scenario.eventbus";

const {OperatorType, CardType, NodeEditorMenuCode, NodeType} = ScenarioService

export default {
    name: "NodeEditor",
    props: {
        node: Object
    },
    data() {
        return {
            CardType,
            OperatorType,
            name: this.node.name,
            editName: false,
            oldNodeString: '',
            oldNodeId: '',
            currentTab: null,
            showSetting: false,
            showAudioEngine: false,
        }
    },
    computed: {
        ...mapState({
            parentMap: state => state.scenario.parentMap,
            nodeList: state => state.scenario.treeData.nodeList,
            nodeHasPortal: state => state.scenario.nodeHasPortal,
            scenarioSetting: state => state.scenario.scenario_setting,
            variableListForSelect: state => state.scenario.variableList.map(item => ({
                text: item.name,
                value: item.name
            }))
        }),
        shouldSave() {
            if (this.node.id === this.oldNodeId) {
                return JSON.stringify(this.node) !== this.oldNodeString
            }
            return false
        },
        isRootNode() {
            return this.node.id === this.$store.state.scenario.treeData.startId
        },
        isEdit() {
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        },
        llmClassifiers() {
            let classifierList = []
            if (this.scenarioSetting) {
                classifierList = this.scenarioSetting.llm_classifier ? this.scenarioSetting.llm_classifier : []
            }
            if (classifierList.length === 0) {
                return []
            } else {
                let configs = []
                classifierList.forEach(item => {
                    configs.push(item.label)
                })
                return configs
            }
        }
    },
    methods: {
        loadDataFromNode() {
            if (this.oldNodeId !== this.node.id) {
                this.oldNodeString = JSON.stringify(this.node)
                this.oldNodeId = this.node.id
            }
        },
        validateNodeData() {
            return true
        },
        validateConditionList(conditionList) {
            if (!conditionList && conditionList.length === 0) {
                return 'Conditions should not empty'
            }
            return true
        },
        saveNode() {
            let validate = this.validateNodeData()
            if (validate === true) {
                this.$appService.showLoading()
                this.$store.dispatch(this.$actionTypes.scenario.UPDATE_NODE, {
                    scenarioId: this.$route.params.scenarioId,
                    id: this.node.id,
                    model: this.getConfig()
                }).then(
                    result => {
                        this.oldNodeString = JSON.stringify(result)
                    }
                ).finally(this.$appService.hideLoading)
                this.$forceUpdate()
            } else {
                this.$appService.toastError(validate)
            }
        },
        deleteNode() {
            let portalList = this.nodeHasPortal[this.node.id]
            if (portalList.length > 0) {
                this.$appService.toastError('There are ' + portalList.length + ' portal to this node, please delete all portal first')
                return
            }
            if (this.node.children.length > 0) {
                this.$appService.toastError('This node has ' + this.node.children.length + ' children, please delete all children first')
                return
            }
            this.$appService.confirm(this.$t('confirmDelete', {item: this.node.name})).then(
                () => {
                    this.$store.dispatch(this.$actionTypes.scenario.DELETE_NODE, {
                        scenarioId: this.$route.params.scenarioId,
                        id: this.node.id
                    })
                }
            )
        },
        getConfig() {
            let {name, config, order} = this.node
            return {name, config, order}
        },
        onMenuSelect(code) {
            switch (code) {
                case NodeEditorMenuCode.ADD_SETTING:
                    if (!this.node.config.setting) {
                        this.node.config.setting = {}
                        this.$forceUpdate()
                    }
                    this.showSetting = true
                    this.currentTab = 'tab-setting' // change tab active to "setting"
                    break
                case NodeEditorMenuCode.ADD_AUDIO_ENGINE:
                    if (!this.node.config.setting) {
                        this.node.config.setting = {}
                        this.$forceUpdate()
                    }
                    this.showAudioEngine = true
                    this.currentTab = 'tab-setting' // change tab active to "setting"
                    break
                case NodeEditorMenuCode.ADD_LLM_CLASSIFIER:
                    if (this.llmClassifiers.length === 0) {
                        this.$appService.toastError('Classifier list empty')
                        break
                    }
                    if (!this.node.config.llmClassifier || this.node.config.llmClassifier.length === 0) {
                        this.node.config.llmClassifier = []
                        this.node.config.llmClassifier.push({
                            label : this.llmClassifiers[0],
                            assignVariable : this.$filters.replaceSpecialCharacters(this.$utils.nonAccentVietnamese(this.llmClassifiers[0]))
                        })
                        this.$forceUpdate()
                        this.saveNode()
                    }
                    this.currentTab = 'tab-setting' // change tab active to "setting"
                    break
                case NodeEditorMenuCode.ADD_NLP_CONFIG:
                    // case node dont have parent
                    if (!this.parentMap[this.node.id]) {
                        let nlpSetting = this.scenarioSetting['nlp_setting']
                        if (!nlpSetting) {
                            this.node.config.nlpConfig = {
                                dontUseNlp: true,
                                label: ''
                            }
                        } else {
                            this.node.config.nlpConfig = {
                                dontUseNlp: false,
                                label: Object.keys(nlpSetting)[0]
                            }
                        }
                    } else {
                        let nodeProcessParent = this.getNodeProcessParent(this.node)
                        if (!nodeProcessParent.config.nlpConfig) {
                            this.node.config.nlpConfig = {
                                dontUseNlp: true,
                                label: ''
                            }
                        } else {
                            this.node.config.nlpConfig = nodeProcessParent.config.nlpConfig
                        }
                    }
                    this.saveNode()
                    this.currentTab = 'tab-setting' // change tab active to "setting"
                    break
                case NodeEditorMenuCode.ADD_API:
                    this.node.config.cardList.push({
                        type: CardType.API,
                        name: CardType.API,
                        data: {
                            method: 'GET',
                            url: '',
                            header: {
                                Authorization: 'Bearer 123'
                            },
                            body: null,
                            query: {},
                            enableApi: true,
                            timeout: 8,
                            conditions: [],
                            configResponses: {},
                            allow_async: false,
                        }
                    })
                    this.currentTab = 'tab-action' // change tab active to "action"
                    break
                case NodeEditorMenuCode.ADD_SET_USER_ATTRIBUTE:
                    this.node.config.cardList.push({
                        type: CardType.SET_USER_ATTRIBUTE,
                        name: CardType.SET_USER_ATTRIBUTE,
                        data: {}
                    })
                    this.currentTab = 'tab-action'  // change tab active to "action"
                    break
                case NodeEditorMenuCode.ADD_LUA:
                    this.node.config.cardList.push({
                        type: CardType.LUA,
                        name: CardType.LUA,
                        data: {script: ''}
                    })
                    this.currentTab = 'tab-action'  // change tab active to "action"
                    break
                case NodeEditorMenuCode.CLONE_NODE:
                    ScenarioEventBus.$emit(
                        ScenarioEventBusType.SELECT_NODE,
                        {
                            item: this.nodeList.filter(item => item.type === this.node.type),
                            resolve: item => {
                                this.node.config = JSON.parse(JSON.stringify(item.config))
                                this.$forceUpdate()
                                this.saveNode()
                            }
                        }
                    )
            }
            this.$nextTick(() => {
                if (code === NodeEditorMenuCode.ADD_SETTING && this.$refs.Setting) {
                    this.$refs.Setting.$el.scrollIntoView()
                    return
                }
                if (this.$refs.card) {
                    let card = this.$refs.card[this.$refs.card.length - 1]
                    if (card) {
                        card.$el.scrollIntoView()
                    }
                }
            })
        },
        getNodeProcessParent(node) {
            let nodeParent = this.parentMap[node.id]
            if (nodeParent.type === NodeType.PROCESS) {
                return nodeParent
            } else {
                return this.getNodeProcessParent(nodeParent)
            }
        },
        deleteCard(index) {
            this.$appService.confirm(this.$t('confirmDelete', {item: this.$t('card')})).then(
                (confirm) => {
                    if (confirm) {
                        this.node.config.cardList.splice(index, 1)
                        this.saveNode()
                    }
                }
            )
        },
        deleteSetting(nameField = '') {
            this.$appService.confirm(this.$t('confirmDelete', {item: this.$t(nameField)})).then(
                (confirm) => {
                    if (!confirm) {
                        return
                    }
                    switch (nameField) {
                        case 'setting': {
                            this.node.config.setting = null
                            this.saveNode()
                            break
                        }
                        default: {
                            return
                        }
                    }
                }
            )
        },
        moveCardUp(index) {
            this.moveCard(index, -1)
        },
        moveCardDown(index) {
            this.moveCard(index, 1)
        },
        moveCard(index, d) {
            if (this.node.config.cardList[index + d]) {
                let tem = this.node.config.cardList[index + d]
                this.node.config.cardList[index + d] = this.node.config.cardList[index]
                this.node.config.cardList[index] = tem
                this.$forceUpdate()
                this.saveNode()
            }
        },
        updateCardName(newName, index) {
            let card = this.node.config.cardList[index]
            if (card) {
                card.name = newName
                this.$forceUpdate()
                this.saveNode()
            }
        },
        closePanelRight() {
            this.$emit('closePanelRight')
        },
        checkShowCardSetting() {
            if (!this.node.config.setting) {
                this.showSetting = false
                this.showAudioEngine = false
                return
            }
            let keys = Object.keys(this.node.config.setting)
            if (keys.length === 0) {
                this.showSetting = false
                this.showAudioEngine = false
                return
            }
            if (keys.includes('audio_engine') || keys.includes('voicedna')) {
                this.showAudioEngine = true
            }

            this.showSetting = true
            switch (keys.length) {
                case 1: {
                    if (keys.includes('audio_engine') || keys.includes('voicedna')) {
                        this.showSetting = false
                        break
                    }
                }
                case 2: {
                    if (keys.includes('audio_engine') && keys.includes('voicedna')) {
                        this.showSetting = false
                        break
                    }
                }
            }
        },
    },
    watch: {
        node: {
            immediate: true,
            deep: true,
            handler: function () {
                this.loadDataFromNode()
                this.checkShowCardSetting()
            }
        }
    }
}
</script>
